import { createContext } from 'react';

export type SlabDrawerCloseHandler = {
  onClose: () => void;
  onUserInteraction: () => void;
};

export type SlabDrawerContextProps = {
  registerCloseHandler: (handler: SlabDrawerCloseHandler | null) => void;
};

export const SlabDrawerContext = createContext<SlabDrawerContextProps>({
  registerCloseHandler: () => null,
});
